<template>
  <el-tooltip
    :disabled="tooltipDisabledInner"
    :content="tooltipContentInner"
    :placement="tooltipPlacement"
    :effect="tooltipEffec"
    v-bind="tooltipProps"
  >
    <template #content>
      <slot name="tooltipContent"></slot>
    </template>

    <div class="ref-box" ref="refBox" v-bind="$attrs" v-on="$listeners">
      <slot name="default"></slot>
    </div>
  </el-tooltip>

  <!-- <span v-else>
    <div class="ref-box" ref="refBox">
      <slot name="default"></slot>
    </div>
  </span> -->
</template>

<script>
export default {
  name: 'HcAutoTooltip',
  props: {
    tooltipDisable: {
      type: Boolean,
      default: false,
    },
    tooltipContent: {
      type: String,
    },
    tooltipPlacement: {
      type: String,
      default: 'top',
    },
    tooltipEffec: {
      type: String,
      default: 'dark',
    },
    tooltipProps: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      innerText: '',
      isOverflow: false,
    }
  },
  computed: {
    tooltipDisabledInner() {
      // 外面禁用 或者 内容没有溢出
      return this.tooltipDisable || !this.isOverflow
    },
    tooltipContentInner() {
      return this.tooltipContent || this.innerText
    },
  },
  methods: {
    flushOverflowState() {
      // scrollWidth > offsetWidth 内容已经溢出
      const refBoxDom = this.$refs?.refBox
      if (!refBoxDom) {
        return
      }
      const offsetWidth = refBoxDom.offsetWidth || 0
      const scrollWidth = refBoxDom.scrollWidth || 0

      this.isOverflow = scrollWidth > offsetWidth
      this.innerText = refBoxDom.textContent
    },
  },
  mounted() {
    this.flushOverflowState()
  },
  updated() {
    this.flushOverflowState()
  },
}
</script>

<style lang="scss" scoped>
.ref-box {
  display: inline-block;
  // 使用者会提供一个最大宽度
  white-space: nowrap;
  word-break: normal;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
